import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import curbsideAPIService from '../services/curbsideAPIService';

export const fetchUser = createAsyncThunk('user/fetchUser', async (id: string) => {
  const response = await curbsideAPIService.get(`staff/${id}`, {});
  return response;
});

export const fetchRoles = createAsyncThunk('user/fetchRoles', async () => {
  const response = await curbsideAPIService.get('role', {});
  return response;
});

export const fetchStores = createAsyncThunk('user/fetchStores', async () => {
  const response = await curbsideAPIService.get('store');
  return response;
});
export const fetchSites = createAsyncThunk('loadOrders/sites', async () => {
  const response = await curbsideAPIService.get('site');
  return response;
});

// Initial state
const initialState = {
  userId: '',
  mode: '',
  roleList: [],
  // raw stores returned by API (storeId, storeName, siteId...)
  storeNames: [] as { storeId: string; storeName?: string; siteId?: string }[],
  // raw sites returned by API
  siteNames: [] as { siteId: string; name?: string }[],
  // selected stores in the { value, label } shape used by GroupedSelect
  selectedStores: [] as { value: string; label: string }[],
  firstName: '',
  lastName: '',
  email: '',
  phoneNumber: '',
  role: 0,
  loading: false,
  error: null as string | null,
};

const userSlice = createSlice({
  name: 'userForm',
  initialState,
  reducers: {
    setFormField: (state, action) => ({
      ...state,
      [action.payload.field]: action.payload.value,
    }),
    setUserId: (state, action) => ({
      ...state,
      userId: action.payload,
    }),
    setUserMode: (state, action) => ({
      ...state,
      mode: action.payload,
    }),
    setSelectedStores: (state, action) => ({
      ...state,
      selectedStores: action.payload,
    }),
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUser.pending, (state) => ({
        ...state,
        loading: true,
      }))
      .addCase(fetchUser.fulfilled, (state, action) => {
        const userData = action.payload;
        return {
          ...state,
          user: userData,
          firstName: userData.firstname ?? '',
          lastName: userData.lastName ?? '',
          email: userData.email ?? '',
          phoneNumber: userData.phoneNumber ?? '',
          role: userData.roleId ?? 0,
          loading: false,
        };
      })
      .addCase(fetchUser.rejected, (state, action) => ({
        ...state,
        error: action.error.message ?? null,
        loading: false,
      }))
      .addCase(fetchRoles.fulfilled, (state, action) => ({
        ...state,
        roleList: action.payload,
      }))
      .addCase(fetchStores.fulfilled, (state, action) => ({
        ...state,
        storeNames: action.payload,
      }))
      .addCase(fetchSites.fulfilled, (state, action) => ({
        ...state,
        siteNames: action.payload,
      }));
  },
});

export const { setFormField, setSelectedStores, setUserId, setUserMode } = userSlice.actions;
export default userSlice.reducer;